import styles from "./index.module.scss";
const Layout = () => {
  return (
    <div className={styles.root}>
      <h1 className="title">
        {" "}
        Шина зимняя шипованная NOKIAN TYRES NORDMAN 5 185/65 R15 92 TX{" "}
      </h1>
      <div className={styles.to_cart}>
        <div className={styles.price}>7000 &#8381;</div>
        <div className={styles.amount}>В наличии 32 шт. </div>
        <button className={styles.button}>Добавить в Корзину </button>
      </div>
      <div className={styles.stats}>
        <h3>Характеристики</h3>
        <div className={styles.hr}></div>
        <div className={styles.characters}>
          <div className={styles.column}>
            <div className="item">
              <p>Бренд</p>
              <span></span>
              <p className={styles.char}>Nokian</p>
            </div>
            <div className="item">
              <p>Ширина, мм</p>
              <span></span>
              <p className={styles.char}>185</p>
            </div>
            <div className="item">
              <p>Высота профиля, %</p>
              <span></span>
              <p className={styles.char}>65</p>
            </div>
            <div className="item">
              <p>Диаметр, дюймы </p>
              <span></span>
              <p className={styles.char}>15</p>
            </div>
            <div className="item">
              <p>Индекс скорости </p>
              <span></span>
              <p className={styles.char}>Т</p>
            </div>
            <div className="item">
              <p>Индекс нагрузки</p>
              <span></span>
              <p className={styles.char}>92</p>
            </div>
            <div className="item">
              <p>Сезонность </p>
              <span></span>
              <p className={styles.char}>зимняя шипованная</p>
            </div>
          </div>

          <div className={styles.column}>
            <div className="item">
              <p>Бренд</p>
              <span></span>
              <p className={styles.char}>Nokian</p>
            </div>
            <div className="item">
              <p>Ширина, мм</p>
              <span></span>
              <p className={styles.char}>185</p>
            </div>
            <div className="item">
              <p>Высота профиля, %</p>
              <span></span>
              <p className={styles.char}>65</p>
            </div>
            <div className="item">
              <p>Диаметр, дюймы </p>
              <span></span>
              <p className={styles.char}>15</p>
            </div>
            <div className="item">
              <p>Индекс скорости </p>
              <span></span>
              <p className={styles.char}>Т</p>
            </div>
            <div className="item">
              <p>Индекс нагрузки</p>
              <span></span>
              <p className={styles.char}>92</p>
            </div>
            <div className="item">
              <p>Сезонность </p>
              <span></span>
              <p className={styles.char}>зимняя шипованная</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.descrip}>
        <h3>Описание </h3>
        <p>Шина шипованная Nokian TYRES NORDMAN 5 185 </p>
      </div>
    </div>
  );
};

export default Layout;
